import { useTranslation } from '@web_opxp/features';
import { useRouteMatch } from 'react-router-dom';
import SideBar, { ISideBarMenuItem } from '../components/SideBarSection/SideBar';
import { IEvaluationPageRouteParams } from './types';

export default function EvaluationSideBar() {
  const {
    path,
    params: { userId },
  } = useRouteMatch<IEvaluationPageRouteParams>();
  const { t } = useTranslation();
  const userEvaluationPath = userId ? `/evaluation/${userId}` : '/evaluation';
  const menuItems: ISideBarMenuItem[] = [
    {
      isActive: path === '/evaluation/:userId?',
      linkTo: userEvaluationPath,
      title: t('common:Header.Menu.TrainingOverview'),
    },
    {
      isActive: path === '/evaluation/:userId?/performance',
      linkTo: `${userEvaluationPath}/performance`,
      title: t('common:Header.Menu.Evaluation'),
    },
    {
      isActive: path === '/evaluation/:userId?/cfq',
      linkTo: `${userEvaluationPath}/cfq`,
      title: t('common:Header.Menu.SelfAssessment'),
    },
    {
      isActive: path === '/evaluation/:userId?/statistics',
      linkTo: `${userEvaluationPath}/statistics`,
      title: t('common:Header.Menu.Statistics'),
    },
  ];
  if (!userId) {
    menuItems.push({
      isActive: path === '/achievements',
      linkTo: '/achievements',
      title: t('common:Header.Menu.Achievements'),
    });
  }
  return <SideBar menuItems={menuItems} />;
}
